// extracted by mini-css-extract-plugin
export var createdDate = "_fn-1";
export var divider = "_fn-2";
export var headerDivider = "_fn-3";
export var messagesCard = "_fn-0";
export var messagesContainer = "_fn-6";
export var messagesContainerWrapper = "_fn-4";
export var showLeftPanelButton = "_fn-8";
export var topButtons = "_fn-7";
export var withPadding = "_fn-5";